module.exports = __webpack_public_path__ + "static/media/MacBook.2d973e69.jpg";